import { render, staticRenderFns } from "./FormularioBloco.vue?vue&type=template&id=7a16fd8c"
import script from "./FormularioBloco.vue?vue&type=script&lang=js"
export * from "./FormularioBloco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports